(function() {
  $(function() {
    var toggle;
    return toggle = new Toggle('.toggle');
  });

  this.Toggle = (function() {
    Toggle.prototype.el = null;

    Toggle.prototype.tabs = null;

    Toggle.prototype.panels = null;

    function Toggle(toggleClass) {
      this.el = $(toggleClass);
      this.tabs = this.el.find(".tab");
      this.panels = this.el.find(".panel");
      this.bind();
    }

    Toggle.prototype.show = function(index) {
      var activePanel, activeTab;
      this.tabs.removeClass('active');
      activeTab = this.tabs.get(index);
      $(activeTab).addClass('active');
      this.panels.hide();
      activePanel = this.panels.get(index);
      return $(activePanel).show();
    };

    Toggle.prototype.bind = function() {
      var _this = this;
      return this.tabs.unbind('click').bind('click', function(e) {
        return _this.show($(e.currentTarget).index());
      });
    };

    return Toggle;

  })();

}).call(this);


$(document).ready(function() {

  /* scroll to target */
  jQuery('.scrollTo').click(function(e) {
      var jump = jQuery(this).attr('href');
      var new_position = jQuery(jump).offset();
      var scroll = 25;
      jQuery('html, body').stop().animate({ scrollTop: new_position.top - scroll }, 800, function(){
          var new_position = jQuery(jump).offset();
          jQuery('html, body').stop().animate({ scrollTop: new_position.top - scroll }, 500);
      });
      e.preventDefault();
  });
  $('.nnouncement-bar-section').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    infinite: true,
    draggable: true,
    arrows: false,
    variableWidth: true
  });
   const scrollers = document.querySelectorAll(".scroller");
    window.matchMedia("(prefers-reduced-motion: reduce)").matches || addAnimation();
    function addAnimation() {
        scrollers.forEach(scroller => {
            scroller.setAttribute("data-animated", !0);
            const scrollerInner = scroller.querySelector(".scroller__inner");
            Array.from(scrollerInner.children).forEach(item => {
                const duplicatedItem = item.cloneNode(!0);
                duplicatedItem.setAttribute("aria-hidden", !0),
                scrollerInner.appendChild(duplicatedItem)
            }
            )
        }
        )
    }

  $('.testimonial-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    infinite: true,
    draggable: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

 // home shop slider
  $('.shop-color-slider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: false,
    infinite: false,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  //accordion js
  //toggle the component with class accordion_body
  $(".accordion_head").click(function () {
    // if ($('.accordion_body').is(':visible')) {
    //   $(".accordion_body").slideUp(300);
    //   $(".plusminus").text('+');
    // }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      
    } else {
      $(this).next(".accordion_body").slideDown(300);
      
    }
  });

  //Store locator js start

  //location left tab js
  $('.tabs-nav span').on('click', function() {
    $([$(this).parent()[0], $($(this).data('href'))[0]]).addClass('active').siblings('.active').removeClass('active');
  });

  

  //store locator accordion js
  //toggle the component with class accordion_body
  $(".location-content-wrapper .location-title").click(function () {
    if ($('.location-content-wrapper .location-content').is(':visible')) {
      $(".location-content-wrapper .location-content").slideUp(300);
      // $(".plusminus").text('+');
    }
    if ($(this).next(".location-content-wrapper .location-content").is(':visible')) {
      $(this).next(".location-content-wrapper .location-content").slideUp(300);
      // $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".location-content-wrapper .location-content").slideDown(300);
      // $(this).children(".plusminus").text('_');
    }
  });

  //Store locator js end

  $('.store-nav li .location').on('click', function () {
    // console.log('this clicked');
    $('.store-nav li .location').removeClass('active-location');
    $(this).addClass('active-location');
  });

  $('.header__icons .new-links .parent-link svg').on('click', function (e) {
    // console.log('link this clicked');
    e.stopPropagation();
    $(this).toggleClass("active-icon");
    $(this).parent().parent().find('.child-links').toggleClass("open-submenu");
    // let current = $(this).parent('.parent-link').find('.child-links');
    // console.log(current);
  });

  $(document).on('click',function(e){
    if($('.new-links .parent-link svg').hasClass('active-icon')){
      $('.new-links .parent-link svg').removeClass('active-icon');
      $('.header--middle-left .header__icons .new-links .child-links').removeClass("open-submenu");
      // console.log("yes");
    }
  });

  $('.menu-drawer__navigation .new-links .parent-link').on('click', function (e) {
    // console.log('link this clicked');
    e.stopPropagation();
    $(this).toggleClass("active-icon");
    $(this).parent().find('.child-links').slideToggle();
    // let current = $(this).parent('.parent-link').find('.child-links');
    // console.log(current);
  });

  $(".wrnty-contact-btn").magnificPopup({
    type: 'inline',
    midClick: true,
    mainClass: 'mfp-fade'
  });

  
});
  
//location top tab js
function filterLocation(locationId) {
  let locationString = locationId;
  // console.log('.tabs-row-wrapper .tab-nav-wrapper .tabs-nav ul li .' + locationString);
  $('.tabs-row-wrapper .tab-nav-wrapper .tabs-nav ul li').hide();
  $('.tabs-row-wrapper .tab-nav-wrapper .tabs-nav ul li.' + locationString).show();
}


$(document).ready(function () {
  const $modal = $(".image_pop_up");
  const $previews = $(".product_image img");
  const $original = $(".full-img");

  $previews.on("click", function () {
    $modal.addClass("open");
    $original.addClass("open");

    var psrc = $(this).attr("data-psrc");

    // Set the high-resolution image URL
    $original.attr("src", psrc);
  });

  // Close modal when clicking outside the image
  $modal.on("click", function (e) {
    if (e.target === this) {
      $modal.removeClass("open");
      $original.removeClass("open");
    }
  });
});


// document.addEventListener("DOMContentLoaded", function () {
//   const modal = document.querySelector(".image_pop_up");
//   const previews = document.querySelectorAll(".product_image img");
//   const original = document.querySelector(".full-img");

//   previews.forEach((preview) => {
//     preview.addEventListener("click", () => {
//       modal.classList.add("open");
//       original.classList.add("open");
//       var psrc = preview.attr('data-psrc');
      
//       // Set the high-resolution image URL
//       original.src = psrc;
//     });
//   });

//   // Close modal when clicking outside the image
//   modal.addEventListener("click", (e) => {
//     if (e.target === modal) {
//       modal.classList.remove("open");
//       original.classList.remove("open");
//     }
//   });
// });





// document.addEventListener('DOMContentLoaded', function () {


//   function handleMediaGalleryVideos() {

//     // pause ALL videos
//     document.querySelectorAll('media-gallery video').forEach(video => {
//       video.pause();
//     });

//     document.querySelectorAll(".product__media-item").forEach(li =>{
//      const rect = li.getBoundingClientRect();

//   const isVisible =
//     rect.left < window.innerWidth &&
//     rect.right > 0;

//   if (isVisible) {
//     li.classList.add("mmmmmmmm");
//   } else {
//     li.classList.remove("mmmmmmmm");
//   }


//     })
//     // find active slide
//     const activeSlide = document.querySelector(
//       'media-gallery .is-active, media-gallery .swiper-slide-active, media-gallery [aria-current="true"]'
//     );

//     if (!activeSlide) return;

//     const video = activeSlide.querySelector('video');

//     if (video) {
//       video.muted = true;
//       video.play().catch(() => {});
//     }
//   }

//   // run initially
//   handleMediaGalleryVideos();

//   // 👇 Shopify slider triggers mutations instead of events
//   const gallery = document.querySelector('media-gallery');

//   if (!gallery) return;

//   const observer = new MutationObserver(() => {
//     handleMediaGalleryVideos();
//   });

//   observer.observe(gallery, {
//     attributes: true,
//     subtree: true,
//     attributeFilter: ['class', 'aria-hidden']
//   });

// });

